import React from "react";
import "../DoctorConsole.scss";
import { useTime } from "react-timer-hook";

const DigitalClockTime = () => {
  const {
    seconds: digSec,
    minutes: digMin,
    hours: digHr,
    ampm,
  } = useTime({ format: "12-hour" });

  // Format with leading zeros
  const formatTime = (val) => String(val).padStart(2, "0");

  // Handle 12-hour clock edge case (00 -> 12)
  const formatHour = (hr) => {
    return hr === 0 ? 12 : hr;
  };

  return (
    <div>
      <h3
        className="console-heading"
        style={{ marginBottom: "2px", color: "#fff" }}
      >
        {`${formatTime(formatHour(digHr))}:${formatTime(digMin)}:${formatTime(
          digSec
        )} ${ampm.toUpperCase()}`}
      </h3>
    </div>
  );
};

export default DigitalClockTime;
